import React from "react"
import clsx from "clsx"
import AutoPriceRuleBuilderErrors from "../AutoPriceRuleBuilderErrors"
import MultiSelect from "../../Selects/MultiSelect"

class AutoPriceRuleBuilderRoomTypes extends React.Component {

    constructor(props) {
      super(props)
    }

    render() {
      // console.log("selected", this.props.selected)
      var tabClasses = clsx({
        'active': this.props.activeTab == 'room_types',
        'tab-pane': true
      })
      var all_room_types = this.props.all_room_types
      var inputs = []
      for(var i = 0; i < all_room_types.length; i++){
        var input = {
          label_primary: all_room_types[i].name,
          status: all_room_types[i].status === 'disabled' ? 'disabled' : null,
          id: all_room_types[i].id
        }
        inputs.push(input)
      }
      var room_types = []
      this.props.auto_price_rules_for_date_range.map((rule) => {
        if(this.props.selected[0] == rule.id){
          room_types = rule.room_types
        } 
      })
      return (
        <div className={tabClasses} id="room_types">
          {/* {this.renderErrors()} */}
          <div className="row">
            <div className="col-md-12">
              {this.props.selected != false && this.props.price_type == 'pace'  
              ?   
                <span>
                  <div style={{width: '20px', height: '20px', display: 'inline-block', backgroundColor: this.props.selected[2].color, position: 'relative', top: '5px'}}></div>
                  {`  ${I18n.t(this.props.selected[2].pace_selector)} ${this.props.selected[2].percentage}`}
                  <span></span>
                  <br></br>
                  <br></br>
                </span> 
              : null
              }
              {this.props.selected != false && this.props.price_type == 'occupancy'  
              ?   
                <span>
                  <div style={{width: '20px', height: '20px', display: 'inline-block', backgroundColor: this.props.selected[2].color, position: 'relative', top: '5px'}}></div>
                  {`  ${this.formatPercentage(this.props.selected[2].occupancy_percentage)} `}
                  <span></span>
                  <br></br>
                  <br></br>
                </span> 
              : null
              }
              { inputs.length
                ?
                  <MultiSelect
                    header_primary="name"
                    inputs={inputs}
                    selected_inputs={room_types}
                    onChange={this.props.onChangeRoomTypes} />
                :
                  <div className="no-records">
                    <span className="none">{I18n.t('none')}</span>
                  </div>
                }
            </div>
          </div>
        </div>
      )
    }
    formatPercentage(num) {
      return parseFloat((num * 100).toFixed(2)) + "%"
    }
  }
export default AutoPriceRuleBuilderRoomTypes
